import { ProgramEnrollment } from 'types/Enrollment';
import { ActionCreator } from 'store/redux/ActionCreators';
import { Programs } from '../../../constants/programs';
import { ErrorTypes } from '../../../constants/errorTypes';

export enum EnrollmentStatusActionType {
  FetchEnrollmentStatusRejected = 'FETCH_ENROLLMENT_STATUS_REJECTED',
  FetchEnrollmentStatusResolved = 'FETCH_ENROLLMENT_STATUS_RESOLVED',
  FetchEnrollmentStatus = 'FETCH_ENROLLMENT_STATUS',
}

export interface FetchEnrollmentStatusPayload {
  fieldTractId: string,
  tenantId: string,
  programId: Programs
}

export interface FetchEnrollmentStatus {
  type: EnrollmentStatusActionType.FetchEnrollmentStatus;
  payload?: FetchEnrollmentStatusPayload;
}

interface FetchEnrollmentStatusResolved {
  type: EnrollmentStatusActionType.FetchEnrollmentStatusResolved;
  payload: ProgramEnrollment[];
}

interface FetchEnrollmentStatusRejected {
  type: EnrollmentStatusActionType.FetchEnrollmentStatusRejected;
  payload: {
    error: ErrorTypes;
  };
}

export type EnrollmentStatusActions =
  | FetchEnrollmentStatus
  | FetchEnrollmentStatusRejected
  | FetchEnrollmentStatusResolved;

export interface EnrollmentStatusActionsCreators {
  fetchEnrollmentStatus: ActionCreator<FetchEnrollmentStatusPayload, FetchEnrollmentStatus>;
  fetchEnrollmentStatusResolved: ActionCreator<
    ProgramEnrollment[],
    FetchEnrollmentStatusResolved
  >;
  fetchEnrollmentStatusRejected: ActionCreator<ErrorTypes, FetchEnrollmentStatusRejected>;
}
